













































import Vue from 'vue'
import Component from 'vue-class-component'
import { User } from '@/classes/User'
import Api from '@/api'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { EHoliday, IHolidayPopupInfo, EScheduleStatuses, ScheduleStatusesMap, AMERICA_TIMEZONE } from '@zunta/configurations'
import momentTz from 'moment-timezone'

@Component({
  components: {
    ModalV2
  }
})
export default class HolidayPopup extends Vue {
  user: User = Api.getUser() as User;
  showPopup: boolean = false;
  EScheduleStatuses = EScheduleStatuses;
  ScheduleStatusesMap = ScheduleStatusesMap;
  userHolidayPopupApi = Api.userHolidayPopup;

  holidayInfo: IHolidayPopupInfo = {
    holiday: EHoliday.Sukkot,
    year: momentTz().get('year'),
    showPeriodStart: momentTz.tz('2026-09-16', AMERICA_TIMEZONE).toDate(),
    showPeriodEnd: momentTz.tz('2026-10-03', AMERICA_TIMEZONE).toDate(),
    scheduleItems: [
      { status: EScheduleStatuses.CLOSED, schedule: 'Mon, Sep 21' },
      { status: EScheduleStatuses.LIMITED_HOURS, schedule: 'Mon, Sep 28 — Fri, Oct 2' },
    ],
  }

  get scheduleMsg () {
    const closureMessage = this.holidayInfo.scheduleItems.find(si => si.status === EScheduleStatuses.CLOSED) ? 'Closure' : ''
    const supportMessage = this.holidayInfo.scheduleItems.find(si => si.status === EScheduleStatuses.LIMITED_HOURS) ? 'Support' : ''
    return ` \
      Please be aware of our upcoming Holiday \
      ${closureMessage && supportMessage ? closureMessage + ' and ' + supportMessage : closureMessage || supportMessage} \
       hours:
    `
  }

  getColor (type: EScheduleStatuses) {
    switch (type) {
      case EScheduleStatuses.CLOSED:
        return 'red'
      case EScheduleStatuses.OPEN:
        return 'green'
      case EScheduleStatuses.LIMITED_HOURS:
        return 'orange'
    }
  }

  async mounted () {
    const { holiday, year, showPeriodStart, showPeriodEnd } = this.holidayInfo
    const now = momentTz.tz(new Date(), AMERICA_TIMEZONE).toDate()
    if (!showPeriodStart || !showPeriodEnd || now < showPeriodStart || now > showPeriodEnd) {
      return
    }
    const userHoliday = await this.userHolidayPopupApi.findUserHolidayPopup(this.user.data.id, holiday, year)
    if (!userHoliday || !userHoliday.viewed) {
      this.showPopup = true
    }
  }

  async markAsViewed () {
    this.showPopup = false
    const { holiday, year } = this.holidayInfo
    await this.userHolidayPopupApi.saveUserHolidayPopup({
      user: this.user.data.id,
      holiday,
      year,
      viewed: true
    })
  }
}
